import * as React from 'react'
import { TaskFileCardConnected } from './TaskFileCardConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const TaskFileCardExamples = () => {
  return (
    <div className="TaskFileCardExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TaskFileCardConnected url="" index={12} />
      </Provider>
    </div>
  )
}
